//============ fixf.core.services.businessprocess.ImportantDocList =============

import {DataPacket} from '@/base/DataPacket';
import {NorDataList} from '@/base/NorDataList';

//============ fixf.core.services.businessprocess.ImportantDoc =============

export class ImportantDoc extends DataPacket {
    constructor(opts= {}){
        super();
        this.FilingPage = opts.FilingPage || null;
        this.FileName = opts.FileName || '';
        this.DocCode = opts.DocCode || '';
        this.IsQualified = opts.IsQualified || false;
        this.KeyId = opts.KeyId || '';
        this.DocumentName = opts.DocumentName || '';
        this.DocumentValue = opts.DocumentValue || '';
        this.Content = opts.Content || '';
        this.ATContentByte = opts.ATContentByte || [];
        this.AttachMentId = opts.AttachMentId || '';
    }
}

export class ImportantDocList extends NorDataList {
    constructor(opts) {
        super();
        for(const item of opts){
           this.append(new ImportantDoc(item));
        }
    }
}

